import { IconButton } from "@mui/material";

import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";
import { SETTLEMENT_STYLES } from "../../style/styles";

export default function SettlementStatusIndicator({ isComplete, visible }) {
  if (!visible) {
    return null;
  }

  return (
    <IconButton disabled={true} className="gap-1">
      <i className="fa-solid fa-money-check-dollar" style={{ color: HNSColors.neutrals[500] }}></i>
      {isComplete ? (
        <Svg
          name={SvgEnum.HisCheck}
          color={HNSColors.success[500]}
          sx={SETTLEMENT_STYLES.statusIcon}
        />
      ) : (
        <Svg
          name={SvgEnum.HisX}
          color={HNSColors.failure[500]}
          sx={SETTLEMENT_STYLES.statusIcon}
        />
      )}
    </IconButton>
  );
}
